import React from "react";

function BarChart() {
    const bar = [
        { id: 1, value: 150 },
        { id: 2, value: 240 },
        { id: 3, value: 1800 },
        { id: 4, value: 2500 },
        { id: 5, value: 1800 },
        { id: 6, value: 1240 },
        { id: 7, value: 2430 },
        { id: 8, value: 1740 },
        { id: 9, value: 1480 },
        { id: 10, value: 1640 },
        { id: 11, value: 2000 },
        { id: 12, value: 2304 },
    ];

    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const data = [
        { id: 1, value: 150, country: "Rajasthan" },
        { id: 2, value: 240, country: "Delhi" },
        { id: 3, value: 1800, country: "Jodhpur" },
        { id: 4, value: 2500, country: "Gujrat" },
        { id: 5, value: 1800, country: "kerala" }
    ];

    const maxValue = Math.max(...bar.map((val) => val.value));


    // Calculating the total sales
    const totalSales = data.reduce((acc, curr) => acc + curr.value, 0);

    // Generating pie chart CSS
    const getPieChartStyle = () => {
        let cumulativePercentage = 0;
        const colorArray = ["#8463d1", "#432585", "#5a3bb0", "#7a5dcf", "#593b99"];

        // Building conic-gradient CSS property
        const pieSegments = data.map((item, index) => {
            const percentage = (item.value / totalSales) * 100;
            const startPercentage = cumulativePercentage;
            cumulativePercentage += percentage;
            return `${colorArray[index % colorArray.length]} ${startPercentage}% ${cumulativePercentage}%`;
        });

        return { background: `conic-gradient(${pieSegments.join(", ")})` };
    };

    return (
        <>

            <div className="deshbord">
                <div className="row">
                    <div className="deshbord-text">
                        <div className="text-a">
                            <h1>Sales Overview</h1>
                        </div>
                        <div className="text-b">
                            <p>Welcome to Books24 Dashboard Template</p>
                        </div>
                        <hr />
                    </div>

                    {/* Bar Chart */}
                    <div className="barChart-Container">
                        <div className="Inner-container">
                            <div className="BarChart">
                                {bar.map((value) => (
                                    <div
                                        className="Chart"
                                        key={value.id}
                                        style={{
                                            height: `${(value.value / maxValue) * 100}%`,
                                            width: "50px",
                                        }}
                                    >
                                        <span>{value.value}</span>
                                    </div>
                                ))}
                            </div>
                            <div className="month-container">
                                {months.map((month, index) => (
                                    <div className="month" key={index}>
                                        <span>{month}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Pie Chart */}
                    {/* <div className="pieChart-Container">
                        <div className="deshbord-text">
                            <div className="text-a">
                                <h1>Sales Distribution by State</h1>
                            </div>
                        </div>

                        <div className="pieChart" style={getPieChartStyle()}></div>
                        <div className="legend-container">
                            {data.map((item, index) => (
                                <div className="legend" key={index}>
                                    <span
                                        className="legend-color"
                                        style={{
                                            backgroundColor:
                                                index % 5 === 0 ? "#8463d1" :
                                                    index % 4 === 0 ? "#432585" :
                                                        index % 3 === 0 ? "#5a3bb0" :
                                                            index % 2 === 0 ? "#7a5dcf" : "#593b99"
                                        }}
                                    ></span>
                                    <span>{item.country}</span>
                                </div>
                            ))}
                        </div>

                    </div> */}


                    <div className="dashboard-container">

                        <div className="dashboard-grid" style={{marginBottom:"25px"}}>
                            <div className="card total-sales-card">
                                <h2>Total Sales</h2>
                                <p className="value">$74,958.49</p>
                                <p className="subtext">$7,395.37 in last month</p>
                                <div className="divider" />
                                <p className="value-small">$1,338.72</p>
                                <p className="growth">↑ 4.63% vs. last week</p>
                                <div className="chart-line">
                                    <svg width="100%" height="100%" viewBox="0 0 100 50">
                                        <polyline
                                            fill="none"
                                            stroke="white"
                                            strokeWidth="2"
                                            points="0,40 10,30 20,35 30,20 40,25 50,15 60,30 70,10 80,20 90,5 100,25"
                                        />
                                    </svg>
                                </div>
                            </div>

                            <div className="card average-order-card">
                                <h2>Average Order</h2>
                                <p className="value">$463.35</p>
                                <p className="growth">↑ 4.63% vs. last week</p>
                                <div className="chart-bar">
                                    <svg width="100%" height="100%" viewBox="0 0 100 50">
                                        <rect x="5" y="20" width="10" height="30" />
                                        <rect x="20" y="10" width="10" height="40" />
                                        <rect x="35" y="15" width="10" height="35" />
                                        <rect x="50" y="5" width="10" height="45" />
                                        <rect x="65" y="25" width="10" height="25" />
                                        <rect x="80" y="15" width="10" height="35" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div className="dashboard-grid">
                            <div className="card orders-card">
                                <h2>Total Carts</h2>
                                <p className="value">329</p>
                                <p className="growth">↑ 4.63% vs. last week</p>
                                <div className="chart-line">
                                    <svg width="100%" height="100%" viewBox="0 0 100 50">
                                        <polyline
                                            fill="none"
                                            stroke="#82ca9d"
                                            strokeWidth="2"
                                            points="0,40 10,30 20,35 30,20 40,25 50,15 60,30 70,10 80,20 90,5 100,25"
                                        />
                                    </svg>
                                </div>
                            </div>
                            <div className="card customers-card">
                                <h2>Customers</h2>
                                <p className="value">194</p>
                                <p className="growth">↑ 4.63% vs. last week</p>
                                <div className="chart-line">
                                    <svg width="100%" height="100%" viewBox="0 0 100 50">
                                        <polyline
                                            fill="none"
                                            stroke="#8884d8"
                                            strokeWidth="2"
                                            points="0,40 10,30 20,35 30,20 40,25 50,15 60,30 70,10 80,20 90,5 100,25"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </>
    );
}

export { BarChart };